<template>
  <section style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    ">
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Sous Verset</v-card-title>
      <v-row class="ml-2">
        <v-col cols="12" sm="6" md="3" xs="12">
          <v-select v-model="surat" :return-object="true" clearable label="Surat" :items="suratArray"
            item-text="arabic_translated_name" outlined @change="SuratSelected"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" xs="12">
          <v-select :return-object="true" clearable v-model="selectedVerset" :items="listVerset" item-text="french_text"
            label="Select a Verse" outlined @change="getListSousversetByVersetId"></v-select>
        </v-col>
      </v-row>
      <!-- Section pour afficher les chunks -->
      <v-row v-if="textChunks.length > 0" class="ml-2 mr-2">
        <v-col cols="12">
          <v-card>
            <v-card-title>Découpage du verset</v-card-title>
            <v-card-text>
              <v-alert v-if="errorMessage" type="error" dense class="mb-4">
                {{ errorMessage }}
              </v-alert>

              <div v-for="(chunk, index) in textChunks" :key="index">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined v-model="chunk.sousVersetText"
                      :label="`Part ${chunk.part} Texte en francais`"></v-text-field>
                    <v-text-field outlined v-model="chunk.sousVersetTextArabic"
                      :label="`Part ${chunk.part} Texte en arabe`"></v-text-field>
                    <v-text-field outlined v-model="chunk.sousVersetTextEnglish"
                      :label="`Part ${chunk.part} Texte en anglais`"></v-text-field>
                    <v-text-field outlined v-model="chunk.sousVersetTextPhonetic"
                      :label="`Part ${chunk.part} Texte phonetique`"></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn :disabled="selectedVerset.length === 0" color="success" @click="save">
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-data-table :no-data-text="noDataText" :items-per-page="itemsPerPage" :page.sync="pageNumber"
        :server-items-length="totallistVersetBySurate" @update:page="getListversetBySouratId(surat)"
        :loading="isLoadingTables" loading-text="Loading..." :headers="headers" :items="listVersetBySurate"
        class="elevation-1" item-key="id" hide-default-footer>
        <template v-slot:[`item.solve`]="{ item }">
          <v-chip v-if="item.solve" variant="outlined">
            <span style="color: #407001">Résolu</span>
          </v-chip>
          <v-chip variant="outlined" v-else>
            <span style="color: red">Non résolu</span>
          </v-chip>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="toggleSolveStatus(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="toggleDelete(item)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
      <!-- Pagination Component -->
      <v-pagination v-model="pageNumber" :length="totalPages" @input="getListversetBySouratId(surat)"></v-pagination>
    </v-card>

    <!-- Modification Dialog -->
    <v-row justify="center">
      <v-dialog v-model="dialogConfirmation" max-width="800" persistent>
        <v-card>
          <v-card-title class="text-h6 text-center">
            Modification Sous Verset List
          </v-card-title>
          <v-row style="margin: 15px">
            <v-col cols="12" sm="12" md="12">
              <v-text-field label="Sous Verset en Francais" outlined v-model="SousVerset.sousVersetText"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field label="Sous Verset en Arab" outlined
                v-model="SousVerset.sousVersetArabicText"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field label="Sous Verset en Anglais" outlined
                v-model="SousVerset.sousVersetTextEnglish"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field label="Sous Verset en phonetique" outlined
                v-model="SousVerset.sousVersetTextPhonetic"></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1 error" text @click="reinitialisation()">
              Annuler
            </v-btn>
            <v-btn color="info darken-1" text @click="ConfirmeSolveStatus()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Deletion Dialog -->
    <v-row justify="center">
      <v-dialog v-model="dialogDelete" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-h6 text-center">
            Confirmer la suppression
          </v-card-title>
          <v-card-text>
            Êtes-vous sûr de vouloir supprimer ce sous-verset ?
            Cette action est irréversible.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" text @click="cancelDelete()">
              Annuler
            </v-btn>
            <v-btn color="info darken-1" text @click="confirmDelete()">
              Supprimer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Snackbar for notifications -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" top right>
      {{ snackbarText }}

      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
import axios from "axios"
import Constant from "@/utils/constants"
import { getAllSurat, getBySurateAdminSpecifique } from "@/views/qorani/services/services"
export default {
  data() {
    return {
      errorMessage: "",
      noDataText: "No Verset found",
      selectedVerset: {},
      listVerset: [],
      pageNumber: 1,
      totalPages: 1,
      itemsPerPage: 10,
      totallistVersetBySurate: 0,
      surat: null,
      listVersetBySurate: [],
      suratArray: [],
      dialogConfirmation: false,
      dialogDelete: false,
      sousVersetToDelete: null,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      icons: {
        mdiFileEyeOutline: "mdi-file-eye-outline",
        mdiPencil: "mdi-pencil",
        mdiDeleteOutline: "mdi-delete-outline",
      },
      search: "",
      isLoadingTables: false,
      listComplaint: [],
      SousVerset: [],
      textChunks: [],
      maxCharsPerChunk: 100,
      maxWordLength: 3,
      headers: [
        { text: "Sous Verset en Arabe", value: "sousVersetArabicText" },
        { text: "Sous Verset en Français", value: "sousVersetText" },
        { text: "Sous Verset en Anglais", value: "sousVersetTextEnglish" },
        { text: "Sous Verset en Phonetic", value: "sousVersetTextPhonetic" },
        { text: "Part", value: "part", align: "center" },
        { text: "Modifier Sous Verset", value: "modifier", align: "center" },
        { text: "Supprimer Sous Verset", value: "supprimer", align: "center" },
      ],
    }
  },
  methods: {
    async save() {
      this.errorMessage = ""
      if (this.textChunks.length === 0) {
        this.errorMessage = "Aucun part à enregistrer"
        return
      }
      const lastChunk = this.textChunks[this.textChunks.length - 1]
      if (!lastChunk.sousVersetText && this.textChunks.length > 1) {
        this.textChunks.pop()
        console.log("Dernier élément supprimé car vide")
        console.log("Nombre de chunks restants:", this.textChunks.length)
      }
      if (this.textChunks.length === 1) {
        if (!this.textChunks[0].sousVersetText) {
          this.errorMessage = "Le texte en français est obligatoire"
          return
        }
      }
      try {
        const dataToSend = this.textChunks.map(chunk => ({
          versetId: this.selectedVerset.versetId,
          part: chunk.part,
          sousVersetText: chunk.sousVersetText,
          sousVersetTextArabic: (!chunk.sousVersetTextArabic || chunk.sousVersetTextArabic.trim() === "")
            ? null
            : chunk.sousVersetTextArabic,
          sousVersetTextEnglish: (!chunk.sousVersetTextEnglish || chunk.sousVersetTextEnglish.trim() === "")
            ? null
            : chunk.sousVersetTextEnglish,
          sousVersetTextPhonetic: (!chunk.sousVersetTextPhonetic || chunk.sousVersetTextPhonetic.trim() === "")
            ? null
            : chunk.sousVersetTextPhonetic,
        }))
        const response = await axios.post(
          `${Constant.QORANI}sousVerset/addSousVerset`,
          {
            sousVersetRequestList: dataToSend
          }
        )
        if (response.data) {
          await this.getListversetBySouratId(this.surat)
          this.textChunks = []
          this.snackbarText = "Sous-versets enregistrés avec succès"
          this.snackbarColor = "success"
          this.snackbar = true
        } else {
          this.errorMessage = response.data.message || "Erreur lors de l'enregistrement"
          this.snackbarText = this.errorMessage
          this.snackbarColor = "error"
          this.snackbar = true
        }
      } catch (error) {
        console.error("Erreur API:", error)
        this.errorMessage = "Une erreur est survenue lors de l'enregistrement"
        this.snackbarText = this.errorMessage
        this.snackbarColor = "error"
        this.snackbar = true
      }
    },

    chunkText(sousVersetText, chunkSize, versetId) {
      if (
        typeof sousVersetText !== "string" ||
        typeof chunkSize !== "number" ||
        chunkSize <= 0
      ) {
        throw new Error("Invalid input parameters.")
      }
      const words = sousVersetText.split(/\s+/)
      const chunks = []
      let chunk = []
      let wordCount = 0
      let charCount = 0
      let part = 1
      for (const word of words) {
        if (word.length > this.maxWordLength) {
          wordCount++
        }
        if (charCount + word.length + chunk.length > this.maxCharsPerChunk) {
          chunks.push({
            part: part,
            sousVersetText: chunk.join(" "),
            sousVersetTextArabic: null,
            sousVersetTextEnglish: null,
            sousVersetTextPhonetic: null,
            versetId: versetId,
          })
          chunk = [word]
          wordCount = word.length > this.maxWordLength ? 1 : 0
          charCount = word.length
          part++
        } else {
          chunk.push(word)
          charCount += word.length
        }
        if (wordCount >= chunkSize) {
          chunks.push({
            part: part,
            sousVersetText: chunk.join(" "),
            sousVersetTextArabic: null,
            sousVersetTextEnglish: null,
            sousVersetTextPhonetic: null,
            versetId: versetId,
          })
          chunk = []
          wordCount = 0
          charCount = 0
          part++
        }
      }
      if (chunk.length > 0) {
        chunks.push({
          part: part,
          sousVersetText: chunk.join(" "),
          sousVersetTextArabic: null,
          sousVersetTextEnglish: null,
          sousVersetTextPhonetic: null,
          versetId: versetId,
        })
      }
      return chunks
    },

    async getListSousversetByVersetId() {
      if (!this.selectedVerset || !this.selectedVerset.versetId) return
      try {
        const response = await axios.get(
          `${Constant.QORANI}sousVerset/getListSousversetByVersetId/${this.selectedVerset.versetId}`
        )
        const data = response.data
        if (data.length > 0) {
          this.textChunks = data.map((chunk) => ({
            ...chunk,
            edit: true
          }))
        } else {
          this.textChunks = this.chunkText(
            this.selectedVerset.french_text,
            6,
            this.selectedVerset.versetId
          )
        }
      } catch (error) {
        console.error("Error fetching sous-versets:", error)
        this.textChunks = this.chunkText(
          this.selectedVerset.french_text,
          6,
          this.selectedVerset.versetId
        )
      }
    },

    async reinitialisation() {
      this.SousVerset = []
      this.dialogConfirmation = false
    },

    async toggleSolveStatus(item) {
      this.SousVerset = item
      this.dialogConfirmation = true
    },

    async ConfirmeSolveStatus() {
      try {
        const response = await axios.post(
          `${Constant.QORANI}sousVerset/editSousVerset/${this.SousVerset.sousVersetId}`,
          {
            sousVersetText: this.SousVerset.sousVersetText,
            sousVersetTextArabic: this.SousVerset.sousVersetTextArabic,
            sousVersetTextEnglish: this.SousVerset.sousVersetTextEnglish,
            versetId: this.SousVerset.versetId,
            sousVersetTextPhonetic: this.SousVerset.sousVersetTextPhonetic,
            part: this.SousVerset.part,
          }
        )
        const index = this.listVersetBySurate.findIndex(
          (item) => item.sousVersetId === this.SousVerset.sousVersetId
        )
        this.$set(this.listVersetBySurate, index, {
          ...this.SousVerset,
        })
        this.dialogConfirmation = false
        this.snackbarText = "Sous-verset modifié avec succès"
        this.snackbarColor = "success"
        this.snackbar = true
      } catch (error) {
        console.error("Error confirming solve status:", error)
        this.snackbarText = "Erreur lors de la modification du sous-verset"
        this.snackbarColor = "error"
        this.snackbar = true
      }
    },

    toggleDelete(item) {
      this.sousVersetToDelete = item
      this.dialogDelete = true
    },

    cancelDelete() {
      this.sousVersetToDelete = null
      this.dialogDelete = false
    },

    async confirmDelete() {
      if (!this.sousVersetToDelete) return
      try {
        await axios.get(
          `${Constant.QORANI}sousVerset/deleteSousVerset/${this.sousVersetToDelete.sousVersetId}`
        )
        await this.getListversetBySouratId(this.surat)
        this.snackbarText = "Sous-verset supprimé avec succès"
        this.snackbarColor = "success"
        this.snackbar = true
        this.cancelDelete()
      } catch (error) {
        console.error("Error deleting sous-verset:", error)
        this.snackbarText = "Erreur lors de la suppression du sous-verset"
        this.snackbarColor = "error"
        this.snackbar = true
        this.cancelDelete()
      }
    },

    async SuratSelected() {
      this.pageNumber = 1
      this.listVerset = await getBySurateAdminSpecifique(this.surat.suratId)
      await this.getListversetBySouratId(this.surat)
      this.textChunks = []
    },

    async getListversetBySouratId(SuratId) {
      try {
        const adjustedPageNumber = this.pageNumber - 1
        const response = await axios.get(
          `${Constant.QORANI}sousVerset/getListSousversetBySuratIdPaginateWeb/${SuratId.suratId}/page/${adjustedPageNumber}`
        )
        this.listVersetBySurate = response.data.sousVersetResponseList || []
        this.totalPages = response.data.totalPageNumber || 1
        this.totallistVersetBySurate =
          response.data.totalElementNumber ||
          response.data.totalPageNumber * this.itemsPerPage
      } catch (error) {
        console.error("Error fetching list of versets:", error)
      }
    },
  },
  async created() {
    this.isLoadingTables = true
    this.suratArray = await getAllSurat()
    this.isLoadingTables = false
  },
}
</script>